//NPM LIBRARIES
import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//REDUX ACTIONS AND SELECTORS
import { getFormDataSelector, getFormPropertiesSelector } from '../FormStore/Selectors/FormDataSelectors';
import { SUBMISSION_SUCCESS } from '../FormStore/Actions/FormServiceActions/GenericFormServiceActions/SubmissionAction';
import { submitAsicVerification } from '../FormStore/Actions/FormServiceActions/DigitalLicenceServiceActions/AsicVerificationSubmissionAction';
import { getCrmReferenceData, FETCH_CRMREFERENCEDATA_SUCCESS } from '../FormStore/Actions/CRMReferenceDataActions';
import { getReferenceDataSelector, getFormServiceStatusSelector } from '../FormStore/Selectors/FormDataSelectors';
import { addPageAlert, clearPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { getB2cSettingsSelector } from '../PortalStore/Selectors/SystemSettingSelectors';

//COMPONENTS AND UTILITIES
import Application from '../components/CASAForm/Application';
import Step from '../components/CASAForm/Step';
import Question from '../components/CASAForm/Question';
import CASASpinner from '../components/Portal/CASASpinner';

class AsicVerification extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formLoaded: false,
            formLoadError: false,
            applicationSubmitting: false,
            radioValue: "",
            verificationAttemptCounter: 0
        }
    }

    componentDidMount() {
        this.props.dispatch(clearPageAlert());

        if (!this.state.formLoaded) {
            this.loadData();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.formProperties.submitForm &&
            prevProps.formProperties.submitForm !== this.props.formProperties.submitForm) {
            this.asicVerificationSubmission()
        }
    }

    loadData = () => {
        const webappurlForms = this.props.b2cSettings.webappurlFormsApi;

        this.props.dispatch(getCrmReferenceData(webappurlForms, this.props.b2cSettings.accesstokenForms, ['ASIC Service Providers']))
            .then(response => {
                if (response.type === FETCH_CRMREFERENCEDATA_SUCCESS) {
                    this.setState({ formLoaded: true });
                } else {
                    this.setState({ formLoaded: true, formLoadError: true, });
                    this.props.dispatch(addPageAlert({
                        level: "error",
                        title: "Unable to complete application online",
                        message: 'Unfortunately this application cannot be completed online. Please contact us for further information.'
                    }));
                }
            })
            .catch(() => {
                this.setState({ formLoaded: true, formLoadError: true, });
                this.props.dispatch(addPageAlert({
                    level: "error",
                    title: "Unable to complete application online",
                    message: 'Unfortunately this application cannot be completed online. Please contact us for further information.'
                }));
            });
    }

    formStepNavigation = (previousStepId, direction) => {
        let currentStep = this.state.currentStep;

        if (direction === 'previous') {
            currentStep--
        } else if (direction === 'next') {
            currentStep++
        }

        this.setState({ currentStep: currentStep })
    }

    asicVerificationSubmission = () => {
        if (this.state.verificationAttemptCounter < 5) {
            const webappurlForms = this.props.b2cSettings.webappurlFormsApi;
            this.setState({ applicationSubmitting: true })

            if (this.props.formData) {
                this.props.dispatch(
                    submitAsicVerification(webappurlForms, this.props.b2cSettings.accesstokenForms, this.props.formProperties, this.props.formData)
                )
                    .then(response => {
                        if (response.type === SUBMISSION_SUCCESS) {
                            // Success message is displayed through portal
                            window.location.replace('/licence-view-multiple/?asicVerified=1');
                        } else {
                            this.setState({ applicationSubmitting: false, verificationAttemptCounter: this.state.verificationAttemptCounter + 1 })

                            if (response.payload === "Failed to retrieve photo") {
                                this.props.dispatch(addPageAlert({
                                    level: "error",
                                    title: "We were unable to access the photograph on your ASIC",
                                    message: "Please try again later."
                                }));
                            } else {
                                this.props.dispatch(addPageAlert({
                                    level: "error",
                                    title: "Unable to verify ASIC",
                                    message: `We have been unable to verify the details of your ASIC. You can only attempt to verify your ASIC ${5 - this.state.verificationAttemptCounter} more times. Please carefully check the details of your ASIC card before trying again.`
                                }));
                            }
                        }
                    })
            }
        } else {
            this.setState({ verificationAttemptCounter: this.state.verificationAttemptCounter + 1 })
            this.props.dispatch(addPageAlert({
                level: "error",
                title: "Unable to verify ASIC",
                message: "We have been unable to verify the details of your ASIC after five attempts. Please try again later."
            }));
        }
    }

    getRadioValue = (selectedOption) => {
        this.setState({
            radioValue: selectedOption.radioValue
        })
    }

    render() {
        let crumbs = [
            {
                link: '/forms/dashind',
                text: 'myCASA'
            },
            {
                link: '/forms/licence-view-multiple',
                text: 'Flight crew licence'
            },
            {
                text: 'ASIC verification and photo lodgement'
            }
        ];

        return (
            <Fragment>
                {this.state.applicationSubmitting ? <CASASpinner message='Submitting form' /> : null}
                {this.state.formLoaded ?
                    <Application
                        formInformation={{
                            id: "asicVerificationForm",
                            name: "ASIC verification and photo lodgement",
                            rootFormCode: "DIG_LIC",
                            formCode: "DIG_LIC_ASIC_VERIFICATION",
                            formDataType: "genericFormData",
                            version: "01"
                        }}
                        formActions={{
                            submit: this.submitForm
                        }}
                        enableSaveButton={false}
                        enableForm={!this.state.formLoadError}
                        showback={false}
                        breadcrumbs={crumbs}
                    >

                        <Step
                            id="asicVerifiation"
                            stepTitle="ASIC card verification"
                            nextStep={this.formStepNavigation}
                            initialStep
                            isLastStep
                            showback={true}
                            backurl={crumbs[1].link}
                            formSubmission={this.asicVerifiationSubmission}
                            key="asicVerifiation">

                            <Question
                                id="issuingBody"
                                key="issuingBody"
                                stepid="notificationType"
                                type="radio"
                                label="Issuing body"
                                hintText={`Your issuing body is who you applied to and received your ASIC from. 
                                It may be printed on the front or back of your ASIC card. If you're unsure of this, 
                                please refer to any correspondence you received regarding your ASIC application or contact your flight school.`}
                                onChangeFunction={this.getRadioValue}
                                radioSet={[
                                    {
                                        name: "aviationId",
                                        id: "aviationId",
                                        value: "AVI",
                                        optionLabel: "Aviation ID Australia"
                                    },
                                    {
                                        name: "casa",
                                        id: "casa",
                                        value: "CAS",
                                        optionLabel: "Civil Aviation Safety Authority"
                                    },
                                    {
                                        name: "vea",
                                        id: "vea",
                                        value: "VEA",
                                        optionLabel: "Veritas (VEA)"
                                    },
                                    {
                                        name: "other",
                                        id: "other",
                                        value: "other",
                                        optionLabel: "Other provider"
                                    }
                                ]} />

                            <Question
                                key="selectProvider"
                                id="selectProvider"
                                type="select"
                                label="ASIC service provider"
                                stepid="asicVerifiation"
                                hintText="Please select your provider from the list below"
                                options={this.props.asicServiceProviders}
                                show={this.state.radioValue === "other" ? true : false} />

                            <Question
                                key="asicNumber"
                                id="asicNumber"
                                type="text"
                                label="ASIC number as shown on card"
                                stepid="asicVerifiation"
                                overwrite={this.state.radioValue === "CAS" ? true : false}
                                disabled={this.state.radioValue === "CAS" ? true : false}
                                existingAnswer={this.state.radioValue === "CAS" ? { value: this.props.user?.items?.value[0].casa_arn, checkboxes: {} } : null}
                                hintText={this.state.radioValue === "CAS" ? 'Your CASA ASIC number is your ARN' : `Please enter the number shown on your ASIC. 
                                This is usually at the bottom of the ASIC and may contain 
                                letters and dashes. Please enter all the characters as 
                                shown on your ASIC.`} />

                            <Question
                                key="asicIssueNumber"
                                id="asicIssueNumber"
                                type="select"
                                label="ASIC issue number"
                                stepid="asicVerifiation"
                                initialValue={'1'}
                                hintText={`Your ASIC issue number appears after your ASIC number a dash.`}
                                block={false}
                                show={this.state.radioValue === "CAS" ? true : false}
                                options={[
                                    { casa_name: '1', casa_code: '1' },
                                    { casa_name: '2', casa_code: '2' },
                                    { casa_name: '3', casa_code: '3' },
                                    { casa_name: '4', casa_code: '4' },
                                    { casa_name: '5', casa_code: '5' },
                                    { casa_name: '6', casa_code: '6' },
                                    { casa_name: '7', casa_code: '7' },
                                    { casa_name: '8', casa_code: '8' },
                                    { casa_name: '9', casa_code: '9' },
                                    { casa_name: '10', casa_code: '10' }
                                ]} />

                            <Question
                                key="firstName"
                                id="firstName"
                                type="text"
                                label="First name as shown on card"
                                stepid="asicVerifiation"
                                hintText={`Please enter your first name as shown on card`} />

                            <Question
                                key="familyName"
                                id="familyName"
                                type="text"
                                label="Family name as shown on card"
                                stepid="asicVerifiation"
                                disabled
                                initialValue={this.props.user?.items?.value[0].lastname} />

                            <Fragment>
                                <h3>Lodgement of photo</h3>
                                <p>By giving your consent below CASA will receive and store your ASIC photo in the ways explained below.</p>
                                <ul>
                                    <li>It will be stored on CASA’s licensing portal for access by authorised CASA officers</li>
                                    <li>It will be stored on CASA’s Medical Records System for access by authorised CASA officers and your Designated Aviation Medical Examiner (<abbr title="Designated Aviation Medical Examiner">DAME</abbr>). This will also enable a <abbr title="Designated Aviation Medical Examiner">DAME</abbr> to verify under <abbr title="Civil Aviation Safety Regulations 1998">CASR</abbr> 67.170 that you are who you claim to be when being medically examined</li>
                                    <li>displayed on your flight crew or air traffic control licence</li>
                                    <li>otherwise disclosed in accordance with <a href="https://www.casa.gov.au/about-us/site-information/privacy-statement">CASA’s privacy statement</a>
                                    </li>
                                </ul>
                                <p>
                                    By giving your consent below CASA will verify your <abbr title="Aviation security identification card">ASIC</abbr> and will also receive and store your <abbr title="Aviation security identification card">ASIC</abbr> photo.
                                </p>
                                <p>
                                    If you do not consent to CASA using this photograph, you cannot download a digital view of your flight crew licence on your iPhone.
                                </p>
                            </Fragment>

                            <Question
                                id="declaration"
                                questionid="declaration"
                                type="declaration"
                                name="declaration"
                                label="I agree and understand the above conditions"
                                value="declaration"
                                stepid="asicVerifiation">
                                <p>I consent to my information being checked
                                with the document issuer or official record holder via third
                                party systems for the purpose of confirming the ASIC was issued
                                and for Auscheck or any ASIC issuing body to disclose to CASA a
                                    copy of any photograph of myself that they hold.</p>
                            </Question>
                        </Step>
                    </Application> : <CASASpinner />}
            </Fragment>
        );
    }
}

AsicVerification.propTypes = {
    children: PropTypes.array,
    dispatch: PropTypes.func,
    smartform: PropTypes.object,
    envdata: PropTypes.object,
    b2cSettings: PropTypes.object,
    ClientApp: PropTypes.object,
    user: PropTypes.object,
    asicServiceProviders: PropTypes.array,
    formProperties: PropTypes.object,
    formData: PropTypes.object,
    submissionStatus: PropTypes.object,
    history: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        user: state.userdetails,
        envdata: state.envdata,
        pageAlert: state.pageAlert,
        formProperties: getFormPropertiesSelector(state.formStore),
        formData: getFormDataSelector(state.formStore, 'genericFormData'),
        b2cSettings: getB2cSettingsSelector(state.B2CSettings, ['webappurlFormsApi', 'accesstokenForms', 'parsed']),
        ClientApp: state.ClientApp,
        asicServiceProviders: getReferenceDataSelector(state.crmReferenceData, 'ASIC Service Providers'),
        submissionStatus: getFormServiceStatusSelector(state.formStore, 'submission')
    }
}

export default connect(mapStateToProps)(AsicVerification);